import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import CustomPagination from '../../components/CustomPagination'
import Layout from '../../components/Layout'
import CustomTable from '../../components/Table/CustomTable'
import CustomTableHeading from '../../components/Table/CustomTableHeading'
import CustomTableRow from '../../components/Table/CustomTableRow'
import { useIncentive } from '../../hooks/Features/useIncentive'
import { formatNumber, getUniqueValues } from '../../shared/constants'
import { NoDataFound } from '../../components/NoDataFound'
import Loader from '../../components/Loader'

export default function QuaterlyEarningReport() {

    const { getQuaterlyEarningReport, loading, paginate, incentives, getPdfCsvData, downloadLoading, pdfCsvData, downloadKeys, positions, managers } = useIncentive()

    const [searchQuery, setSearchQuery] = useState('')

    const startDate = new Date()
    startDate.setDate(1)
    startDate.setHours(0, 0, 0)
    startDate.setMonth(1)
    const [from, setFrom] = useState(startDate.toISOString())
    const [to, setTo] = useState(new Date().toISOString())

    const [page, setPage] = React.useState(1)

    const [filterParams, setFilterParams] = useState({ storeName: null, rank6Name: 1, managerRank: '', managerId: '' })

    const noOfPages = paginate.totalPage;

    useEffect(() => {
        getQuaterlyEarningReport({ from, to, ...filterParams, searchQuery, page })
    }, [from, to, filterParams, searchQuery, page])

    useEffect(() => {
        getPdfCsvData(downloadKeys.QUATERLY_EARNING_REPORT, { from, to, rank6Name: 1 })
    }, [from, to])

    const handleChange = (event, value) => {
        setPage(value)
    }

    const tableHeading = ['Store', ...positions.filter((item) => item && item.rank === 6).map(item => item.positionName), 'Q1', 'Q2', 'Q3', 'Q4', 'Total']

    return (
        <Layout
            heading="Quarterly Earning Report"
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            selectedFrom={from}
            setSelectedFrom={setFrom}
            selectedTo={to}
            setSelectedTo={setTo}
            headers={pdfCsvData.headings}
            data={pdfCsvData.headingValues}
            filename="quaterly-earning-report"
            downloadLoading={downloadLoading}
            filterRank={filterParams.managerRank}
            setFilterRank={(val) => setFilterParams({ ...filterParams, managerRank: val, managerId: '' })}
            filterName={filterParams.managerId}
            setFilterName={(val) => setFilterParams({ ...filterParams, managerId: val })}
            filterNamesOptions={managers && managers[`rank${filterParams.managerRank}`] ? managers[`rank${filterParams.managerRank}`] : []}
            filterRankOptions={positions ? positions.map(item => ({ value: item.rank, name: item.positionName })) : []}
        >
            <CustomTable>
                <CustomTableHeading
                    heading={tableHeading}
                />
                <TableBody>
                    {!loading &&
                        incentives.length > 0 &&
                        incentives.map((item, index) => {
                            return (
                                <CustomTableRow key={index}>
                                    <TableCell> {item.storeName} </TableCell>
                                    <TableCell> {item.rank6Name} </TableCell>
                                    {item.quarter.map((quat) => {
                                        return <TableCell>{formatNumber(quat)}</TableCell>
                                    })}
                                    <TableCell>{formatNumber(item.incentiveStoreWillGet)}</TableCell>
                                </CustomTableRow>
                            )
                        })}
                </TableBody>
            </CustomTable>

            {
                !loading && incentives.length > 0 && (
                    <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />
                )
            }

            {!loading && !incentives.length && <NoDataFound text="No Incentive Found" />}

            {loading && <Loader />}
        </Layout >
    )
}